import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class Routes {
  constructor() {
    _defineProperty(this, "routes", {});
    _defineProperty(this, "helpers", {});
  }
  /**
   * Add a mithril route to the application.
   *
   * @param name The name of the route.
   * @param path The path of the route.
   * @param component must extend `Page` component.
   */
  add(name, path, component) {
    this.routes[name] = {
      path,
      component
    };
    return this;
  }
  helper(name, callback) {
    this.helpers[name] = callback;
    return this;
  }
  extend(app, extension) {
    Object.assign(app.routes, this.routes);
    Object.assign(app.route, this.helpers);
  }
}
flarum.reg.add('core', 'common/extenders/Routes', Routes);